import { useSpritesheetStore } from "../../../store/spritesheetStore";
import { getScoreColor } from "../../utils/get-score-color";
import { getAvatarStyle } from "../../utils/spritesheet";
import { Typography } from "../Typography";
import css from "./Table.module.scss";

interface TableHeaderProps {
  columns: { label: string; alignment: string; flex?: number }[];
}

interface TableRowProps {
  children: any;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

interface TableCellProps {
  children: any;
  className?: string;
}

interface TableContainerProps {
  children: any;
  className?: string;
}
interface WinAmountProps {
  amount: number | null;
}
interface BetAvatarProps {
  username?: string;
  size?: number;
  avatar: string;
  className?: string;
  classNameAvatar?: string;
}
interface MultiplierProps {
  value: number | null;
  isMyBet?: boolean;
}
interface DateTimeDisplayProps {
  date: string;
  time: string;
}

export const TableContainer = ({
  children,
  className,
}: TableContainerProps) => {
  return (
    <div className={`${css.tableContainer} ${className || ""}`}>
      {children}
      <div className={css.provablyFair}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.8613 9.25391L9.53027 12.4375L8.80762 11.7471V11.7461L7.13867 10.1523L7.86133 9.46094L9.5293 11.0557L12.1387 8.5625L12.8613 9.25391Z"
            fill="#707071"
          />
          <path
            d="M15.6494 10C15.6494 13.0998 13.2893 15.9395 10.1396 16.6338L10 16.665L9.86035 16.6338C6.7107 15.9395 4.35059 13.0998 4.35059 10V6.56055L4.75879 6.39746L9.75879 4.39746L10 4.30078L10.2412 4.39746L15.2412 6.39746L15.6494 6.56055V10Z"
            stroke="#707071"
            stroke-width="1.29873"
          />
        </svg>

        <Typography variant="caption1" color="light-grey">
          Provably Fair Game
        </Typography>
      </div>
    </div>
  );
};

export const TableHeader = ({ columns }: TableHeaderProps) => {
  return (
    <div className={css.tableHeader}>
      {columns.map(({ label, alignment, flex }, index) => (
        <div
          key={index}
          className={css.headerCell}
          style={{ textAlign: alignment, flex: flex }}
        >
          <Typography color="light-grey" variant="caption2">
            {label}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export const TableRow = ({
  children,
  className,
  onClick,
  style,
}: TableRowProps) => {
  return (
    <div
      className={`${css.tableRow} ${className || ""}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
};

export const TableCell = ({ children, className }: TableCellProps) => {
  const cellClass = `${css.rowCell} ${className || ""}`;

  return <div className={cellClass}>{children}</div>;
};

export const BetAvatar = ({
  username,
  avatar,
  size = 24,
  className,
  classNameAvatar,
}: BetAvatarProps) => {
  // Subscribe to spritesheet store to trigger re-render when avatars are ready
  const avatarsReady = useSpritesheetStore((s) => s.avatarsReady);
  const atlasStyle = avatarsReady ? getAvatarStyle(avatar, size) : null;

  return (
    <div className={`${css.container} ${className || ""}`}>
      <div
        className={`${css.avatar} ${classNameAvatar}`}
        style={{ width: size, height: size }}
      >
        {atlasStyle ? (
          <div style={atlasStyle} />
        ) : (
          <div
            style={{
              width: size,
              height: size,
              background: "#333",
              borderRadius: "50%",
            }}
          />
        )}
      </div>
      {username && (
        <Typography color="light-grey" variant="caption2">
          {username}
        </Typography>
      )}
    </div>
  );
};

export const Multiplier = ({ value, isMyBet }: MultiplierProps) => {
  return (
    <Typography
      color={isMyBet && value ? getScoreColor(value) : "white"}
      variant="caption2"
      className={css.multiplier}
    >
      {value === null || !value ? "-" : `${value?.toFixed(2)}x`}
    </Typography>
  );
};

export const WinAmount = ({ amount }: WinAmountProps) => {
  return (
    <Typography className={css.winAmount} variant="caption2">
      {amount === null || !amount ? "-" : amount?.toFixed(2)}
    </Typography>
  );
};

export const DateTimeDisplay = ({ date, time }: DateTimeDisplayProps) => {
  return (
    <div className={css.dateTime}>
      <span className={css.icon}>📅</span>
      <Typography color="light-grey" variant="caption2">
        {date}
      </Typography>
      <span className={css.icon}>🕐</span>
      <Typography color="light-grey" variant="caption2">
        {time}
      </Typography>
    </div>
  );
};
